// 한 판 오케스트레이션: 원시 신호 → 점수·곡선·유형·판정 → 최종 결과.
// 행동/곡선/유형은 전부 로컬. 판정만 AI(목/폴백).

import type { Judge, JudgeInput } from "./judge";
import { fallbackJudgement } from "./judge";
import { defaultJudge } from "./judgeClient";
import { computeBehavior, finalScore } from "./scoring";
import { computeCurve } from "./curve";
import { classify } from "./archetype";
import { record } from "./storage";
import type { Lang, RawSignals, VerdictResult } from "./types";

export interface VerdictOptions {
  judge?: Judge; // 기본 defaultJudge(엔드포인트 설정 시 httpJudge, 아니면 mockJudge).
  persist?: boolean; // 기본 true. 로컬 배지장 기록.
}

export async function runVerdict(
  signals: RawSignals,
  lang: Lang,
  opts: VerdictOptions = {},
): Promise<VerdictResult> {
  const judge = opts.judge ?? defaultJudge;

  // 1) 로컬 계산 (즉시, 네트워크 무관).
  const behavior = computeBehavior(signals);
  const curve = computeCurve(signals);
  const archetype = classify(signals, behavior, curve);

  // 2) AI 판정 (실패 시 폴백 → 루프 안 끊김, §12).
  const input: JudgeInput = {
    score: behavior.behaviorScore,
    signals,
    archetype,
    lang,
    now: new Date(),
  };
  let judgement;
  try {
    judgement = await judge.judge(input);
  } catch {
    judgement = fallbackJudgement(archetype, lang);
  }

  // 3) 크라이시스 또는 범위 밖(슬픔 등)이면 점수·기록 없이 즉시 반환.
  //    우선순위: crisis > off_scope.
  if (judgement.crisis || judgement.off_scope) {
    return { score: 0, signals, behavior, curve, archetype, judgement };
  }

  // 4) 최종 점수 + 로컬 기록.
  const score = finalScore(behavior.behaviorScore, judgement.content_factor);
  if (opts.persist !== false) record(score, archetype);

  return { score, signals, behavior, curve, archetype, judgement };
}
